module.exports = __webpack_public_path__ + "img/banner-14.4a5bdb19.jpg";